// extracted by mini-css-extract-plugin
module.exports = {"item":"InformationCartPage_item__BatUz","section":"InformationCartPage_section__3fvcU"};